const Constants = {
  WS_BRAND_CONNECTIONS: {
    zillow: 'wss://www.zillow.com/rental-manager-api/ws/services',
    hotpads: 'wss://hotpads.com/rental-manager-api/ws/services',
    trulia: 'wss://www.trulia.com/rental-manager-api/ws/services',
    TEST: 'ws://localhost:8080',
  },
  UNFORMATTED_BRAND_NAMES: {
    hotpads: 'hotpads',
    zillow: 'zillow',
    trulia: 'trulia',
  },
  FORMATTED_BRAND_NAMES: {
    hotpads: 'HotPads',
    zillow: 'Zillow',
    trulia: 'Trulia',
  },
  NOTIFICATION_CENTER_ENDPOINTS: {
    getAllNotificationsEndpoint: '/rental-manager-api/api/v1/users/notifications/allNotifications',
    deleteNotificationEndpoint: '/rental-manager-api/api/v1/users/notifications/delete',
    markAsReadEndpoint: '/rental-manager-api/api/v1/users/notifications/markAsRead',
    markAllAsReadEndpoint: '/rental-manager-api/api/v1/users/notifications/updateAll',
    updateReadTimestampEndpoint: '/rental-manager-api/api/v1/users/tracking?trackingEvent=refreshNotificationCenter',
  },
  NOTIFICATION_TYPES: {
    DRAFT_REMINDER: 'DRAFT_REMINDER',
    LEAD_ADDED: 'LEAD_ADDED',
    SYNDICATION_STATUS_UPDATED: 'SYNDICATION_STATUS_UPDATED',
    LISTING_NEARLY_EXPIRED: 'LISTING_NEARLY_EXPIRED',
    LISTING_EXPIRED: 'LISTING_EXPIRED',
    CONVERSATION_UPDATED: 'CONVERSATION_UPDATED',
    NEW_APPLICATION_REQUEST: 'NEW_APPLICATION_REQUEST',
    APPLICATION_RECEIVED: 'APPLICATION_RECEIVED',
    APPLICATION_UNREAD: 'APPLICATION_UNREAD',
    APPLICATION_WITHDRAWN: 'APPLICATION_WITHDRAWN',
    CUSTOMER_LISTING_PROBLEM: 'CUSTOMER_LISTING_PROBLEM',
    NEW_UPDATED_INVOICE: 'NEW_UPDATED_INVOICE',
    REVIEW_CREATED: 'REVIEW_CREATED',
    ENTERPRISE_LISTING_DECLINED: 'ENTERPRISE_LISTING_DECLINED',
    USER_MANAGEMENT_INVITATION: 'USER_MANAGEMENT_INVITATION',
    LISTING_COMPLETENESS: 'LISTING_COMPLETENESS',
  },
};

export default Constants;
